export default {"src":"/_next/static/media/short-answer-mini.ce1137d3.svg","height":24,"width":24};